/**
 * Firebaseの設定ファイル
 * 
 * 実際の使用時には、Firebaseコンソールから取得した実際の設定値に置き換えてください。
 * https://console.firebase.google.com/
 */

// Firebaseの設定
export const firebaseConfig = {
  apiKey: "AIzaSyAJ8mmF8e1zZmFEx7vFDStoej2gqVZd56k", 
  authDomain: "richika-chat.firebaseapp.com", 
  projectId: "richika-chat",
  storageBucket: "richika-chat.appspot.com",
  messagingSenderId: "961533487498",
  appId: "1:961533487498:web:6a1f377c94e9d95f6cfa9d",
  measurementId: "G-8L9LBRLJ9T"
};
